const KEY_TARGETS: Record<string, (i: number, n: number) => number> = {
	ArrowRight: (i, n) => (i + 1) % n,
	ArrowLeft: (i, n) => (i - 1 + n) % n,
	Home: () => 0,
	End: (_, n) => n - 1
};

/** Index the tablist keyboard pattern moves to from `current` of `count`, or undefined if `key` isn't a tab key. */
export function nextTabIndex(key: string, current: number, count: number): number | undefined {
	return KEY_TARGETS[key]?.(current, count);
}

/** Attachment for a `role="tablist"`: arrow/Home/End move focus and activate, skipping `aria-disabled` tabs. */
export function tablistKeys(list: HTMLElement) {
	const onKeydown = (e: KeyboardEvent) => {
		const tabs = [
			...list.querySelectorAll<HTMLElement>('[role="tab"]:not([aria-disabled="true"])')
		];
		const next = nextTabIndex(e.key, tabs.indexOf(e.target as HTMLElement), tabs.length);
		if (next === undefined || !tabs.includes(e.target as HTMLElement)) return;
		e.preventDefault();
		tabs[next].focus();
		tabs[next].click();
	};
	list.addEventListener('keydown', onKeydown);
	return () => list.removeEventListener('keydown', onKeydown);
}
